// Libraries
import React from "react";
import { useObserver } from "mobx-react-lite";

// Custom
import { IEGridCategoryModel } from "../../IEmodels";
import { CommercialViewModel } from "../../Commercial.ViewModel";
import { PackagesViewModel } from "../../PackagesViewModel";
import { formatCurrencyForGrid, formatCurrencyNoSign } from "Utils/Format";

// Styling & Images
import { ToggleButton } from "../VariationGrid.Styles";
import { RowDash } from "Views/Project/CustomComponents";
import { formatCreditDebitClass, formatCreditDebitReverseClass } from "Utils/Utils";

interface ITableProps {
    itemModel: IEGridCategoryModel;
    rowType: string;
    variationIndex: number;
    rowIndex: number;
    iEId: string;
    rowEnable(variationIndex: number, index: number): void;
    currentActiveVarIndex: number;
    currentActiveCatIndex: number;
}

export const VariationCat: React.FunctionComponent<ITableProps> = (props) => {
    const { itemModel, rowType, variationIndex, rowIndex, rowEnable, currentActiveVarIndex, currentActiveCatIndex } = props;
    const packagesViewModel = PackagesViewModel.Instance;
    const commercialViewModel = CommercialViewModel.Instance;

    const formatDebit = (val: number) => {
        return commercialViewModel.formatDebit(val);
    };

    const handleName = () => {
        return packagesViewModel.getCategoryName(itemModel.sourceId);
    };

    return useObserver(() => (
        <>
            <li className={rowType} key={"cat_" + rowIndex}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <div
                        style={{
                            color: `${currentActiveVarIndex === variationIndex && currentActiveCatIndex === rowIndex ? "#0095DA" : ""}`,
                            paddingLeft: "10px",
                            display: "flex",
                            alignItems: "center",
                        }}
                    >
                        <RowDash style={{ display: "inline-block", marginRight: "10px" }} />
                        <span className="variation-row-name variation-cat-name" title={handleName()}>
                            {handleName()}
                        </span>
                    </div>
                    {currentActiveVarIndex === variationIndex && currentActiveCatIndex === rowIndex ? (
                        <ToggleButton marginLeft={"26px"}>
                            <span
                                className={"open"}
                                onClick={() => {
                                    rowEnable(-1, -1);
                                }}
                            >
                                &minus;
                            </span>
                        </ToggleButton>
                    ) : (
                        <ToggleButton marginLeft={"26px"}>
                            <span
                                className={"opcloseen"}
                                onClick={() => {
                                    rowEnable(variationIndex, rowIndex);
                                }}
                            >
                                &#43;
                            </span>
                        </ToggleButton>
                    )}
                </div>
                <div className="right">{formatCurrencyForGrid(formatCurrencyNoSign(itemModel.income))}</div>
                <div className="right">{formatCurrencyForGrid(formatCurrencyNoSign(itemModel.estimateCost))}</div>
                <div className="right">{itemModel.margin}</div>
                <div className={"right" + formatDebit(itemModel.committedCost)}>{formatCurrencyForGrid(formatCurrencyNoSign(itemModel.committedCost))}</div>
                <div className="right">{formatCurrencyForGrid(formatCurrencyNoSign(itemModel.futureSpend))}</div>
                <div className="right">{formatCurrencyForGrid(formatCurrencyNoSign(itemModel.totalExpectedSpend))}</div>
                <div className={"right" + formatCreditDebitClass(itemModel.variance)}>{formatCurrencyForGrid(formatCurrencyNoSign(itemModel.variance))}</div>
                <div className={"right" + formatCreditDebitReverseClass(itemModel.roValue)}>{formatCurrencyForGrid(formatCurrencyNoSign(itemModel.roValue))}</div>
                <div className="right" style={{ display: "flex", alignItems: "center", justifyContent: "space-around" }}></div>
            </li>
        </>
    ));
};
